/**
 * Работа с описаниями словарей
 */

// ⛓️ CURSOR_ANCHOR:search:dict-description

// Функция для получения описания словаря
function getDictDescription(dictName) {
  if (!window.DICT_DESCRIPTIONS) {
    return '';
  }
  
  var descriptions = window.DICT_DESCRIPTIONS;
  
  // Проверяем прямое совпадение
  if (descriptions[dictName]) {
    return descriptions[dictName];
  }
  
  // Проверяем вложенные категории (для RU языка)
  var categories = ['ru_scn', 'en_scn', 'tolk', 'etym'];
  for (var i = 0; i < categories.length; i++) {
    var cat = categories[i];
    if (descriptions[cat] && descriptions[cat][dictName]) {
      return descriptions[cat][dictName];
    }
  }
  
  return '';
}

// Экспорт для использования в других модулях results/
window.SEARCH_RESULTS_DICT_DESC = {
  getDictDescription: getDictDescription
};

